import { useTranslation } from "@opendash/i18n";
import { Flex, Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { getFieldPath } from "../../../functions/Utility";
import { SpecificRule } from "../../../types/RuleTypes";
import { ListFieldContext } from "../LaterForm";
import { RuleContext } from "../LaterRule";
import { NumberRange } from "./NumberRange";
import { PeriodSelect } from "./PeriodSelect";

type Props = {};

const RELATIVE_VALUES = ["first", "last"];

export const OnThe_TimeInput = observer((props: Props) => {
  const t = useTranslation();
  const rule = useContext(RuleContext) as SpecificRule<"on_the">;
  const field = useContext(ListFieldContext);
  const options = useMemo(
    () =>
      RELATIVE_VALUES.map((value) => ({
        label: t(`opendash:cron.later.relativeTime.${value}`),
        value,
      })),
    [t]
  );

  return (
    <Flex vertical gap="small" style={{ width: "100%" }}>
      <Form.Item name={[getFieldPath(field), "relativeTime"]}>
        <Select
          allowClear
          options={options}
          placeholder={t("opendash:cron.later.relativeTime.placeholder")}
        />
      </Form.Item>

      {!rule?.relativeTime && (
        <Form.Item name={[getFieldPath(field), "numberRange"]}>
          <NumberRange />
        </Form.Item>
      )}

      <Form.Item name={[getFieldPath(field), "period"]}>
        <PeriodSelect />
      </Form.Item>
    </Flex>
  );
});
